/**
 * Initial state for user permissions in the application.
 * This state defines the permissions related to user roles.
 *
 * Currently, it has only permissions for viewing, creating, and updating pricing/profitability.
 * Any additional permissions can be added in the future as needed.
 */

export const userPermissionsInitialState = {
    pricing: {
        view: false,
        create: false,
        update: false,
    }
};